import React, { PureComponent } from 'react';
import {message,Button, Table} from 'antd';
import Cookie from "@utils/cookie";
import PropTypes from "prop-types";
import SearchForm from '@components/SearchForm/SearchForm'
import dayjs from 'dayjs';
import {isEmpty,isEmptyObject,trim, toFixed2,formatNumberToPrice,symbolMoneyUtil} from '@utils/utils';
import Lang from "@components/Lang/Lang";
import AuthBtn from "@components/HoverIcon/AuthBtn";
import AutoFetchTableService from "./AutoFetchTable.action";
import Locale from "@utils/locale";
import "./Index.less";
const config = require("../../../config/config");
const locale = Locale.current();
/**
 * 搜索表格组件
 * @author FJJ
 * @version 1.0
 *
 * 必传 的 参数
 * columns 栏目:[{
 *          cnTitle：lang的默认显示值
 *          cnTitleId: lang 对应KEY
 *          dataIndex: 数据读取ID，
 *          key: lang的Key值
 *          title: 官方参数，无传 cnText 时，显示 title 内容
 *          type:'timestampToDate' 可选渲染类型，时间戳转日期，默认'YYYY-MM-DD',
 *              'money' 价格显示格式，带千位符，默认'，'
 *               'millisecondToTime ' :当前时间减传入时间，并将时长毫秒数转时长显示，默认'时:分'
 *      }]
 * fetchApi 查询方法
 * onRef 组件通讯使用，绑定后调用 handleFetch 重新获取数据
 * handleFetch 外部调用重新搜索方法，参数(页码=1, 接口发送的搜索条件 = {}, 是否合并使用上次搜索条件=false)
 * fetchCallBack 获取数据完成后回调
 *
 * 辅助参数
 * userPropsColumns 是否使用远程栏目,默认否，只处理一次
 * initFetch        进入是否查询 默认为true
 * fetchCondition   搜索条件
 * footer           底部 默认否
 * pageSize         默认显示10条
 * rowClassName     表格行类名
 * rowSelection     选择行 默认null
 * paginationFlag   是否显示页码 默认 true
 *  showQuickJumper  是否快速跳页 默认 true
 *  showSizeChanger 是否修改改页码 默认 true
 * flagShowReset    是否显示重置
 * rowKey           行Key值
 * precondition     搜索前置条件
 * specialHandle    特别处理(查询前处理)
 * scroll           滚动配置
 * scrollTop: PropTypes.bool,
 * topSearchFarLeft: PropTypes.func, // 搜索表单最左的内容
 * callBackFields      回调内容List取值，如取model下的itemList,即['model','orderItemList']，
 *                  不传直接取models(建设接口都直接将数据放进models，不用传callBackMap)
 *
 * configTable   其他配置，表格的配置查看antd5.0
 *
 * 待扩展：
 * 显示相关 columns中传入配置
 *
 * type 显示类型
 * enumClass 若type=='Enum' 则须配置枚举类取字典数据配合显示
 * @copyright 2021-2021, all rights reserved. Essa.cn
 *
 *
 * 方法
 * searchReset          重置方法，谨传，传此方法请自行处理重置数据逻辑
 **/
class AutoFetchTable extends PureComponent {
    static propTypes = {
        showHeader: PropTypes.bool,
        columns: PropTypes.array.isRequired,
        fetchApi: PropTypes.string.isRequired,
        onRef: PropTypes.func,
        fetchCallBack: PropTypes.func,
        initFetch: PropTypes.bool,
        fetchCondition: PropTypes.object,
        footer: PropTypes.func,
        size: PropTypes.string,
        rowClassName: PropTypes.any,
        rowSelection: PropTypes.any,
        scroll: PropTypes.object,
        paginationFlag: PropTypes.bool,
        pageSize: PropTypes.number,
        rowKey: PropTypes.string,
        flagShowReset: PropTypes.bool,
        flagShowSearchBtn: PropTypes.bool,
        showTotal: PropTypes.bool,
        searchFormOptions: PropTypes.array,
        specialHandle: PropTypes.func,
        topSearchFarLeft: PropTypes.any, // 搜索表单最左的内容
        topSearchLeftCont:PropTypes.any,
        topSearchRightCont:PropTypes.any,
        searchReset:PropTypes.func,
        precondition: PropTypes.object,
        scrollTop: PropTypes.bool,
    }
    static defaultProps = {
        userPropsColumns:false,
        showHeader:true,
        columns: [],
        initFetch: true,
        fetchApi:'',
        size:'default',
        rowClassName:'editable-row',
        rowSelection: null,
        paginationFlag: true,
        flagShowReset: true,
        flagShowSearchBtn: true,
        topSearchLeftCont:null, // 搜索左则内容
        topSearchRightCont:null, // 搜索右则内容
        pageSize:10,
        rowKey:'id',
        // showTotal:false,
        searchFormOptions: [],
        scroll: {},
        precondition:{},
        showQuickJumper:false,
        showSizeChanger:false,
        bordered:false,
        scrollTop:true,
        configTable:{}
    };
    constructor(props) {
        super(props);
        this.handleColumns = this.handleColumns.bind(this)
        this.state = {
            columns: props.columns ? this.handleColumns(props.columns) : [],
            current: props.current ? props.current : 1,
            pagination: props.pagination ? props.pagination : {
                showQuickJumper: props.showQuickJumper,
                showSizeChanger: props.showSizeChanger,
                pageSize:props.pageSize,
                current: props.pageNum||1,
                // showTotal: (total) =>props.showTotal?`${Lang({id:"ZongGong",default:'总共'})} ${total}`:"",
                position:["","bottomCenter"],
            },
            loading: false,
            size: props.size,
            rowClassName: props.rowClassName,
            lastSearch: {}, //上一次的搜索条件
            rightCollapse:false,
        }
    }
    //处理栏目
    handleColumns(formatColumns){
        if(formatColumns&&formatColumns.constructor === Array){
            // const { dictionary } = this.props;
            formatColumns.forEach((column,i) => {
                if(column.cnTitleId){
                    let titleStr ='';
                    if(column.cnTitleId.constructor===Array){
                        const list = column.cnTitleId;
                        list.forEach((item,index)=>titleStr += Lang({id: item, default: column.cnTitle[index]})+'/');
                        titleStr = titleStr.substr(0,titleStr.length-1);
                    }else titleStr = Lang({id: column.cnTitleId, default: column.cnTitle});
                    column.title =titleStr;
                }
                if(column.type&&column.type=='timestampToDate'){
                    column['render'] = (timestamp, record) => dayjs(timestamp).format('YYYY-MM-DD');
                }
                if(column.type&&column.type=='millisecondToTime'){
                    column['render'] =  (timestamp, record) => this.getSubmissionTime(timestamp);
                }
                if(column.type&&column.type=='money'){
                    column['render'] = (text, record) => {
// <<<<<<< HEAD
//                         const num = isEmpty(text)?'0':toFixed2(text);
//                         if(locale=='ru'){
//                             if(!isEmpty(column.showSymbol)){
//                                 return (<div>{splitNumberRu(num)}<span className={"margin-left-5"}>{record[column.showSymbol]}</span></div>)
//                             } else return (<div>{splitNumberRu(num)}</div>)
//                         }else if(!isEmpty(column.showSymbol)) return <span>{record[column.showSymbol]}<span className={"margin-left-5"}> {formatNumberToPrice(num,',',true)}</span></span>
//                         return formatNumberToPrice(num,',',true);
// =======
                        if(!isEmpty(column.showSymbol)){
                            return symbolMoneyUtil(text,record[column.showSymbol])
                        } else{
                            const num = isEmpty(text)?'0':toFixed2(text);
                            return formatNumberToPrice(num,',',true);
                        } 
// >>>>>>> remotes/origin/master
                    }
                }
            })
        }
        return formatColumns;
    }
    /**
     * 刷新栏目
     * */
    reRefreshColumns(){
        this.setState({
            columns:this.handleColumns(this.props.columns)
        })
    }
    // 格式化 时长
    getSubmissionTime(timestamp) {
        if(isEmpty(timestamp)){
            return ''
        }
        const value =new Date().getTime()-timestamp; // 时长毫秒数
        let over24Hour = false;
        let theTime = parseInt(value/1000);// 秒
        let middle= 0;// 分
        let hour= 0;// 小时
        let result = "";
        if(theTime > 60) {
            middle= parseInt(theTime/60);
            // if(middle > 0) {
            //     result = middle + Lang({id: 'Fen', default: '分'});
            // }
            if(middle> 60) {
                hour= parseInt(middle/60);
                middle= parseInt(middle%60);
            }
            result = middle > 9 ? middle : '0'+middle;
            if(hour> 0) {
                if(hour>=24) over24Hour = true;
                result = hour + ':'+result; //hour +Lang({id: 'XiaoShi', default: '小时'})+' '+result;
            }else result = '0:'+ result;
        }else result = '0:01'// 1 + Lang({id: 'Fen', default: '分'});
        return over24Hour?<span className={'span-red'}>{result}</span>:<span>{result}</span>;
    }
    /**
     * 切换页面
     * @param pagination 页码数据
     * @param filters 筛选
     * @param sorter  排序
     */
    handleTableChange = (pagination, filters, sorter) => {
        const pager = { ...this.state.pagination };
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        const { lastSearch } = this.state; //点击页面带当前搜索条件
        if(sorter&&sorter.order&&sorter.column&&sorter.column.sorterCustom){ // 自定义排序方法
            let newObj =  {...lastSearch}
            newObj = sorter.column.sorterCustom(newObj,sorter.order);
            this.setState({ // 排序值 不保存和搜索state时
                pagination: pager,
            },()=> this.fetch(pagination.current,newObj,false));
        }else {
            this.setState({
                pagination: pager,
            },()=> this.fetch(pagination.current,lastSearch));
        }
    }
    /**
     * 查询并加载数据
     * @param pageIndex  查询页码
     * @param params  查询参数
     * @param flagUseLastSearch  是否采用上次的搜索条件
     */
    handleFetch = (pageIndex=1,params = {}, flagUseLastSearch = false) => {
        this.loading(true)
        if(flagUseLastSearch){
            const { lastSearch } = this.state;
            params = { ...lastSearch}
        }else {
            this.setState({
                lastSearch : params
            })
        }
        this.fetch(pageIndex, params)
    }
    loading(flag){
        this.setState({
            loading: flag
        })
    }
    /**
     * 重置
     **/
    searchReset(){
        if(this.props.searchReset){
            this.props.searchReset();
        }else this.fetch(1,{});
    }
    /**
     * 搜索表格 搜索
     ***/
    getFormData(values={}) {
        // let map = {}
        // console.log("getFormData values",values)
        // for(let key in values){
        //     if(!isEmpty(values[key]))map[key] = typeof values[key]=='string'?trim(values[key]):values[key];
        // }
        // console.log("map",map)
        this.fetch(1,values)
    }
    /**
     * 搜索
     * @param pageIndex 页码
     * @param fetchCondition 条件
     */
    fetch(pageIndex=1,fetchCondition={},saveLastSearch=true){
        this.loading(true);
        const { fetchApi,precondition} = this.props;
        const { pagination:{pageSize},} = this.state;
        let newSearchMap = {...precondition,...fetchCondition};
        for(let key in newSearchMap){
            if(isEmpty(newSearchMap[key])) delete newSearchMap[key];
        }
        if(this.props.specialHandle){
           const newL = this.props.specialHandle(newSearchMap);
            newSearchMap={...newSearchMap,...newL}
        }
        AutoFetchTableService.fetch(fetchApi,pageSize, pageIndex,newSearchMap).then((resp)=>this.handleRes(resp.data,pageIndex,fetchCondition,saveLastSearch)).catch(err=>this.handleErr(err));
    }
    handleRes(res={},pageIndex=1,fetchCondition={},saveLastSearch=true){
        const {success,valid,models,paging} = res;
        if (success && valid) {
            if(this.props.fetchCallBack){
                this.props.fetchCallBack(res);
            }
            const { callBackFields,scrollTop} = this.props;
            const resList = callBackFields&&callBackFields.length>0?this.getResList(res,callBackFields):[...models];
            if(resList.length>0){
                const {pagination,} = this.state;
                const newPagination = { ...pagination,
                    total: paging&&paging.total?paging.total:resList.length,
                    pageSize:  paging&&paging.pageSize?paging.pageSize:this.props.pageSize,
                    current: paging&&paging.pageNum?paging.pageNum:1
                }
                let newStateData = {
                    list: resList,
                    pagination:newPagination,
                }
                if(saveLastSearch){
                    newStateData["lastSearch"] = fetchCondition
                }
                this.setState(newStateData,()=>{
                    if(scrollTop){
                        window.scrollTo(0, 0);
                    }
                });
            }else this.resetList(fetchCondition,saveLastSearch);
        }else {
            this.resetList(fetchCondition,saveLastSearch);
            if(res.message)message.error(res.message);
        }
        this.loading(false);
    }
    getResList(res={},resMap=[]){
        let list={...res};
        resMap.forEach(key=>{
            list =  list[key]
        })
        if(list&&list.constructor!=Array){
            return [list]
        }else return list
    }
    /**
     * 重置页面
     * */
    resetList(fetchCondition,lastSearch=true){
        const {pagination} = this.state;
        let newPageState = {
            list: [],
            pagination:{
                ...pagination,
                total: 0,
                current:1
            },
        }
        if(lastSearch) {
            newPageState["lastSearch"] = fetchCondition
        }
        this.setState(newPageState)
    }
    handleErr(err){
        this.loading(false);
    }
    /**
     * 导出
     */
    handleExport = async () => {
        //  /data/bpms/jreport/mg/fexiaoCommission/withdrawItem/print
        const { exportSetting } = this.props
        if(exportSetting){
            const { exportUrl,exportTemplate,otherParams } = exportSetting;
            let {userId} = Cookie.getJSON("fmg.extra") || {};
            let href =  config.servers[config.environment].exportApi + `${exportUrl}?template=${exportTemplate}&userId=${userId}`;
            if(!isEmptyObject(otherParams)){//拼接其他参数
                for(let key in otherParams){
                    href+='&'+key+'='+otherParams[key];
                }
            }
            //地址拼接，如果没有数据也要拼接
            href += `&langCode=${locale}`;
            href += "&isCheck=0";
            const values = await this.onRefSearchFrom.getSearchFromValue();
            for(let key in values){
                if(values[key]){
                    const value = values[key];
                    if(value.constructor !== Array)href += `&${key}=${values[key]}`;
                }
            }
            window.open(href);
        }
    };
    /**
    * 右则
    * */
    getRight(topSearchRightCont,exportSetting={}){
        let children = []
        if(exportSetting.exportUrl&&exportSetting.exportTemplate){
            const btnExport =(<div className={'textRight'}>
                {
                    exportSetting.authName?<AuthBtn fontSize="14px" icon={"ri-logout-box-r-line"} className="export-style"
                        title = {Lang({id:"DaoChuShuJu",default:"导出数据"})}
                        tips = {Lang({id:"DaoChuShuJu",default:"导出数据"})} 
                        auth={exportSetting.authName} 
                        onClick={() =>this.handleExport()} />:
                        <Button onClick={() =>this.handleExport()}
                            icon={<span className="ri-logout-box-r-line font_14"></span>}>
                            <span className="font_12">{Lang({id: "DaoChuShuJu"})}</span>
                        </Button>
                }
            </div>);
            if(topSearchRightCont){
                children.push(topSearchRightCont)
            }
            children.push(btnExport)
        }else if(topSearchRightCont){
            children.push(topSearchRightCont)
        }
        return children;
    }
    onRefSearch = (ref) =>  this.onRefSearchFrom = ref;
    /**
     * 进入 加载数据 列表
     */
    componentDidMount() {
        if(this.props.onRef)this.props.onRef(this);
        if(this.props.initFetch){
            let fetchCondition = {};
            if(this.props.fetchCondition)fetchCondition=this.props.fetchCondition;
            this.fetch(1,fetchCondition);
        }
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render() {
        const { userPropsColumns=false,bordered,topSearchFarLeft, topSearchLeftCont, topSearchRightCont,topSearchLeftRight,
            searchFormOptions,paginationFlag,rowKey,flagShowReset,exportSetting,
            flagShowSearchBtn,summary,scroll,children,precondition, showHeader,configTable={}} = this.props;
        const { loading, list, size, rowClassName, pagination,columns, } = this.state;
        return (<div className={"auto-fetch-table"}>
                    {searchFormOptions.length>0&&<div className={'top-search'}>
                        <SearchForm
                            onRef={this.onRefSearch}
                            options = {searchFormOptions}
                            searchLeft = {topSearchFarLeft}
                            setRight = {this.getRight(topSearchRightCont,exportSetting)}  //  UI混来混去的锅，只能各种配置
                            setLeft = {topSearchLeftCont}  //  UI混来混去的锅，只能各种配置
                            setLeftBtnRight = {topSearchLeftRight}  //  UI混来混去的锅，只能各种配置
                            initialValues={precondition}
                            searchReset={(dat)=>this.searchReset(dat)}
                            flagShowReset={flagShowReset}
                            flagShowSearchBtn={flagShowSearchBtn}
                            getSearchValue={this.getFormData.bind(this)} />
                    </div>}
            {children}
                    <Table {...configTable} showHeader={showHeader}
                    columns={ userPropsColumns?this.handleColumns(this.props.columns):columns }  //栏目
                    rowKey={record => rowKey?record[rowKey]:record.id}    // KEY
                    dataSource={list}  // 数据源
                    pagination={paginationFlag?pagination:paginationFlag}         //页码
                    loading={loading}    //加载
                    scroll={scroll}
                    bordered={bordered}
                    onChange={this.handleTableChange} // 点击切换页码事件
                    rowSelection={this.props.rowSelection ? this.props.rowSelection : null}  // 勾选框
                    rowClassName= {rowClassName} //表格行的类名
                    summary={summary}
                    size = {size}        //大小
                    sticky
                    footer={ this.props.footer }      //底部默认null
                />
            </div>);
    }
}


export default AutoFetchTable;
